import axios from 'axios'

export default class MenuResource {
  menus () {
    return axios.get('/api/menus')
  }

  permissions () {
    return axios.get('/api/permissions')
  }

  search (keyword, userType = '') {
    return axios.get(`/api/search?query=${keyword}&user_type=${userType}`)
  }

  pageButtonsPermissions(){
    return axios.get('api/pageButtonsPermissions')
  }

}
